<template>
  <v-card>
    <v-card-title>
      <div>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          clearable
          dense
          outlined
          rounded
          @input="onSearch"
        ></v-text-field>
      </div>
      <v-btn icon text @click="getList">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="(selected.length > 0)" @click="balanceCells">Balance Cells</v-btn>
      <v-btn color="error" class="ml-4" v-if="(selected.length > 0)" @click="deleteCells">Delete Cells</v-btn>
    </v-card-title>
    <v-data-table 
      :headers="dataColumns"
      :items="cellList"
      :loading="loading"
      :server-items-length="totalCellList"
      :options.sync="options"
    >
      <template v-slot:top>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.number" label="Cell #" :readonly="true"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.value" label="Value"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.power" label="Power"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.pov" label="Power / Value" :readonly="true"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="updating">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn text @click="editItem(item)" class="mr-1">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn text @click="deleteItem(item)" color="red">
          <v-icon small>delete</v-icon> Delete
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import api, { balancedcells } from "@/api";
import { debounce } from "lodash";
// import Spreadsheet from "@/core/Spreadsheet/Spreadsheet.vue";

export default {
  name: "Batteries",
  props: {
    refresh: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    editButton: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    deleteButton: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    selectButton: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    selectCell: Function
  },
  data: () => ({
    loading: false,
    options: {},
    dataColumns: [
      {
        type: 'numeric',
        value: 'number',
        text: 'Cell #',
      },
      {
        type: 'numeric',
        value: 'value',
        text: 'Value',
      },
      {
        type: 'numeric',
        value: 'power',
        text: 'Power',
      },
      {
        type: 'numeric',
        value: 'pov',
        text: 'Power / Value',
      },
      {
        text: "Actions",
        value: 'action'
      }
    ],
    cellList: [],
    totalCellList: 0,
    selected: [],
    sort: undefined,
    updates: [],
    search: "",
    dialog: false,
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    updating: false
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    }
  },
  methods: {
    async getList() {
      const { page = 1, itemsPerPage = 10 } = this.options;
      this.loading = true;
      const query = { filter: { status: "unbalanced" } };
      if (this.sort) {
        query.sort = this.sort;
      }
      const response = await api.getCellsList(itemsPerPage, page, this.search, [], query);
      this.totalCellList = response.data.count;
      this.cellList = response.data.data;
      this.loading = false;
    },
    onSearch: debounce(function() {
      this.getList();
    }, 200),
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.editedIndex = this.cellList.indexOf(item)
      this.dialog = true
    },

    async deleteItem (item) {
      const confirm = await this.$alert.confirm();
      if(confirm && confirm.value === true) {
        try {
          await api.deleteCells([item.number]);
          this.getList()
          this.$toast.success({ title: "Deleted Successfully" })
        } catch (error) {
          this.$toast.error({ title: "Error Deleting" })
        }
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },

    async save () {
      if (this.editedIndex > -1) {
        try {
          this.updating = true;
          await api.updateCell(this.editedItem)
          Object.assign(this.cellList[this.editedIndex], this.editedItem)
          this.editedIndex = -1;
          this.$toast.success({title: "Cell Updated Successfully"});
        } catch (error) {
          this.$toast.error({title: "Error Updating"});
        }
        this.updating = false;
      }
      this.close()
    },
  },
  mounted() {
    this.getList();
  },
};
</script>